// extracted by mini-css-extract-plugin
export default {"root":"DraggableItem_root__wsPd2"};